/* Owner asked for the mobile nav drawer to cover the search bar too,
   not start just below it. Stock positions the drawer via --header-end
   (main.js setHeaderEnd(), measured off the whole <store-header>'s own
   height) - confirmed via direct getBoundingClientRect inspection that
   .header__search is a flex-wrap child INSIDE the same .header__grid
   row as the logo/icons (not a separate section below it), so
   --header-end naturally includes its height already, landing the
   drawer right below it instead of above it.

   .header__icons' own bottom edge (confirmed identical to
   .main-menu__toggle's) marks exactly where the icon row ends and the
   wrapped search-bar row begins, so using THAT instead of the whole
   header's height gives the "logo/icon row only" offset the owner
   wants, without touching main.js's own --header-end (still used
   elsewhere, e.g. the sticky-header and Expert-help panel math). */
(function () {
  function update() {
    var iconsRow = document.querySelector('.header__icons') || document.querySelector('.main-menu__toggle');
    if (!iconsRow) return;
    var bottom = iconsRow.getBoundingClientRect().bottom;
    if (bottom <= 0) return;
    document.documentElement.style.setProperty('--llm-mobile-nav-top', bottom.toFixed(1) + 'px');
  }

  window.addEventListener('load', update);
  window.addEventListener('on:debounced-resize', update);
  document.addEventListener('DOMContentLoaded', update);
  update();
})();
